module.exports = __webpack_public_path__ + "media/images/loading-7bf21e35.svg";